import React, { useState, useEffect,useContext } from 'react';
import '../styles/filing.css'
import { Link, useNavigate,useParams  } from 'react-router-dom';
import DynamicIcon from '../components/dynamicicon';
import JisButton from '../components/controls/jisButton';
import JisDropdown from '../components/controls/jisDropdown';
import FlowItem from '../components/controls/flowitem';
import { ShareContext } from '../context/ShareContext';
import Gazette from '../components/core/gazette';
import * as Constants from '../constants';
import BackLoader from '../components/backloader';
import Payment from '../components/core/payment';
import JisDialog from '../components/dialog';


function FilingClaim() {
     const FeeTYPEID=31;
      const navigate = useNavigate()
        const { caseid } = useParams();
        
         const {  activePage, token, profile,frequentData,setIsExpired} = useContext(ShareContext);
         const [cinfo, setCase] =useState(null);
         const [flow, setFlow] = useState({pos:1, code:"claims"});
         const [flowerror, setFlowError]=useState('');
          const [casefeeId, setcasefeeId] = useState(null)
          const [parties, setParties]= useState([]);
          const [isSuccess, setIsSuccess]= useState(false);
          const [loading, setLoading] = useState(false);
          const [count,setCount]=useState(0);
          const [isLoaded, setIsLoaded]= useState(false);
          const [claimtitle, setClaimTitle]=useState('Claim'); //so we can set if its Claim, Counter claim or Offence
       const [claims, setClaims] = useState([{ claim:'',claimValue:'',currencyType:'' }]);
       const [claimids, setclaimIds] = useState('');
         const currencies=[
        {label:'Naira (N)',value:"Naira" },
        {label:'Dollar ($)', value:"Dollar"},
        {label:'Euro (e)', value:"Euro"},
    ] 
            const [removingIndex, setRemovingIndex] = useState(null);

            const onChangeClaim = (index, key, value) => {
  setClaims(prev =>
    prev.map((item, i) => i === index ? { ...item, [key]: value } : item)
  );
};

const onRemoveClaims = async (index) => {
    if(claims.length==1){
        return;
    }

    const h=claims[index];
        if(h && h.id>0){
            await onRemoveClaim_Server(h.id);
        }
     setRemovingIndex(index);
  setTimeout(() => {
    setClaims(prev => prev.filter((_, i) => i !== index));
    setRemovingIndex(null);
  }, 300); // match fadeOut duration

 
};

const onAddClaim = () => {
  setClaims(prev => [...prev, { claim:'',claimValue:'',currencyType:''}]);
};
const onRemoveClaim_Server= async(id)=>{
    //for account registration
    try {
      setLoading(true);
        const resp = await fetch(`${Constants.apiUrl}/filing/remove-claim/${id}`, { 
          method: 'POST',  headers: {  'Content-Type': 'application/json','Authorization':  `Bearer ${token}`,}, });  
        const data = await resp.json();
       setLoading(false);
        if(data.code==0){
            //caseinfo,parties, claims, causes
           console.log(data);
        } else if(data.code==-10){
                      setIsExpired(true);
                  }

      } catch (error) {
        setLoading(false);
        console.error(error);   
      }
}
             const onGazetteProceed=(e)=>{
              console.log('after processing... here is value')
              console.log(e);
              setcasefeeId(e.feeid);
              setIsSuccess(e.isPaid);
              if(!e.isPaid){
                on_gazette();
              }
          }
              const on_gazette=()=>{
              setFlow({pos:3,code:"payment"});
          } 
             const on_payment_back=()=> setFlow({pos:2,code:"gazette"});
         
            useEffect(() => {
              if(caseid!=null){
                 onLoad(caseid);
              }
                        
            }, [caseid]);
      const onLoad= async(_caseid)=>{
                  //for account registration
              try {
      
                  setLoading(true);
                  const resp = await fetch(`${Constants.apiUrl}/filing/mini-case-details/${_caseid}`, { 
                      method: 'GET',  headers: {  'Content-Type': 'application/json','Authorization': `Bearer ${token}`,}, });  
                  const data = await resp.json();
                  setLoading(false);
                  if(data.code==0){
                      //ready
                      // fee, feelines, cinfo , parties 
                    setCase(data.caseinfo)
                      setParties(data.parties.filter(c=>c.legalCounselId==profile.id));
                      setIsLoaded(true);
                      var cc=data.caseinfo?.caseTypeId == 2 ? 'Offences' : 'Claims'
                      
                      if(profile.id!=data.caseinfo.createdById){
                            setClaimTitle(`Counter ${cc}`)
                      }else{
                        setClaimTitle(cc);
                      }
                  } else if(data.code==-10){
                      setIsExpired(true);
                  }
                  
                  } catch (error) {
                  setLoading(false);
                  console.error(error);   
                  }
              }

 const on_claims=async(e)=>{
    e.preventDefault();
   
     setLoading(true);
                    
    try {

        const resp = await fetch(`${Constants.apiUrl}/filing/claim/${caseid}`, {
        method: 'POST',
            body:JSON.stringify(claims) ,
        headers: {
            'Content-Type': 'application/json, text/plain',
            'Authorization': `Bearer ${token}`,
        },
        });
        
        const data = await resp.json();
        setLoading(false);
        console.log(data);
        if (data.code === 0) {
            //setGazettes(data.gazettes);
            setFlow({pos:2,code:"gazette"});
        }else {   
        
        }
    } catch (error) {
        setLoading(false);
        console.error(error);
        // setErr(Constants.serverErr);
        // onMove();
    }

        
    }
     const onGotoDetails = () =>{
    setIsSuccess(false);
    navigate(`/document-upload/${casefeeId}`); //navigate to login

}
  return (
    <div>

      <div style={{textAlign:'center'}}><h2>{cinfo?.caseTitle?.toUpperCase()}</h2>
        <h3>{cinfo?.caseNumber}</h3>
        </div>
        <div className='multiform'>
          <div  className='flow'>
            <div className='itemgroup'>
                 <FlowItem flow={flow} pos={1} code="claims" title={`${claimtitle} Details`}  />
                <FlowItem flow={flow} pos={2} code="gazette" title="Gazette" />
                <FlowItem flow={flow} pos={3} code="payment" title="Payment"  isLast={true}/>
            </div>
          </div>
          {flow.code=='claims' &&  <div className='view'>
        <form onSubmit={on_claims}>
            {claims.map((claim, index) => (
            <div key={index} className={`claim-item ${removingIndex === index ? 'removing' : ''}`}>
                <div style={{ flex: 1 }}>
                
                <div  className="input-group">
                        <label>  {claimtitle} <span className="required">*</span> </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="group" />
                            <textarea placeholder='e.g Money Laundering' required={true}  value={claim.claim}
                    onChange={(e) => onChangeClaim(index, 'claim', e.target.value)}   />
                        </div>
                    </div>

              {cinfo?.caseTypeId != 2 && <div style={{ display: 'flex', gap: 8 }}>
                    
                    <div className="select-group">
                        <label>
                            Currency Type 
                        </label>
                        <select name="gender"  value={claim.currencyType}
                    onChange={(e) => onChangeClaim(index, 'currencyType', e.target.value)} >
                            <option value="">Select </option>
                            {currencies.map((opt) => (
                            <option key={opt.value} value={opt.value}>
                                {opt.label}
                            </option>
                            ))}
                        </select>
                    </div>

                    <div  className="input-group">
                        <label> Claim Value (Numbers only) </label>
                        <div className='input-wrapper'>
                            <DynamicIcon iname="money" />
                            <input required={claim.currency}  placeholder="eg 300" 
                            value={Constants.formatCurrency(claim.claimValue) }
                             onChange={(e) => onChangeClaim(index, 'claimValue', e.target.value)}  />
                        </div>
                    </div>
                  
                </div>}  
                </div>
                <div  onClick={() => onRemoveClaims(index)} className='delete'>
                <DynamicIcon iname="trash-2"/> Delete
                </div>
            </div>
        ))}
            <JisButton icon="add" onClick={onAddClaim}>Add {claimtitle}</JisButton>

         <div className='flowbuttongroup'>
                        
                        <JisButton type='submit' loading={loading}>Proceed</JisButton>
                    </div> 
        </form>
       
        </div>}
         {flow.code=='gazette' &&  <div className='view'>
        <Gazette filingtypeid={cinfo?.caseFilingId} levelid={cinfo?.caseCategoryId}   feetypeid={FeeTYPEID}
        token={token} onProceed={(e)=>onGazetteProceed(e)} caseid={cinfo?.caseId} feeId={casefeeId}>
             <div className="top-nav">
                <div className="left-top">
                    <div className="top">
                        <h2>{cinfo?.referenceNumber} | {Constants.getItemById(frequentData.casecategories,cinfo?.caseCategoryId)?.categoryTitle}</h2>
                        
                    </div>
                    <p>Select items related to the {claimtitle}</p>
                </div>
                <p className="nav-status">{claimtitle} Filing /Specifications</p>
            </div>

        </Gazette>


        </div>} 
      {flow.code=='payment' && <div className='view'>

        <Payment feeid={casefeeId} token={token} />
        
         <div className='flowbuttongroup'>
                        <JisButton onClick={on_payment_back}>Back</JisButton>
                       
                    </div>
        </div>} 

        </div>

         <BackLoader open={loading} />
         {isSuccess && <JisDialog title="Case Created Successfully.">
                 <div>Additional Claim/Counter Claim created successfully.  Payment is not required. Please continue to upload document</div>
                     <JisButton onClick={onGotoDetails} >Upload document</JisButton>
               </JisDialog>} 
    </div>
  );
}

export default FilingClaim;